import { render, staticRenderFns } from "./NewPasswordForm.vue?vue&type=template&id=0171daa2&scoped=true&"
import script from "./NewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./NewPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordForm.vue?vue&type=style&index=0&id=0171daa2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171daa2",
  null
  
)

export default component.exports